import { VFC } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { putIntroductoryText } from 'src/api/introductoryText'
import { DEFAULT_IMAGE } from 'src/assets/images'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { SmallButton } from 'src/elements/Button'
import { RequestBoxCompany } from 'src/models/RequestBox'
import {
  _formalert,
  _introductory_text_border,
  _menuicon,
  _profilegreen,
  lightgray,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

const IntroductoryTextModalContent: VFC<
  ModalProps<{ company: RequestBoxCompany; mutate: () => void }>
> = ({ close, company, mutate }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      content: company.introductoryText.content || '',
    },
  })

  const handleOnSubmit: SubmitHandler<{ content: string }> = async ({
    content,
  }) => {
    await putIntroductoryText(company.id, content)
    mutate()
    close()
  }

  return (
    <Layout>
      <LayoutPadding1>
        <FormTitle>紹介文編集</FormTitle>

        <Flex>
          <ItemContentImage src={company.imageUrl || DEFAULT_IMAGE} />
          <div>
            <CompanyName>{company.name}</CompanyName>
            <CompanyAdminName>{company.adminName}</CompanyAdminName>
          </div>
        </Flex>
      </LayoutPadding1>

      <LayoutPadding2>
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <div>
            <ContentLabel htmlFor="content">紹介文内容</ContentLabel>
          </div>
          <ContentTextarea
            {...register('content', { required: '紹介文を入力してください' })}
          />
          <ErrorMessage>
            <p>{errors.content && errors.content.message}</p>
          </ErrorMessage>
          <ModalButtons>
            <CancelButton type="button" onClick={close}>
              もどる
            </CancelButton>
            <SaveButton type="submit" disabled={isSubmitting}>
              作成
            </SaveButton>
          </ModalButtons>
        </form>
      </LayoutPadding2>
    </Layout>
  )
}

export const IntroductoryTextModal = asModal(IntroductoryTextModalContent, {
  scrollable: true,
})

const Layout = styled.div`
  width: 80vw;
  max-width: 700px;
  border-radius: 10px;
  background-color: ${truewhite};
  line-height: 1.3rem;
  max-height: 80vh;
  overflow-y: auto;
`
const LayoutPadding1 = styled.div`
  padding: 5% 5% 0;
`
const LayoutPadding2 = styled.div`
  border-top: 1px solid ${_menuicon};
  padding: 2.5% 5% 5%;
`
const FormTitle = styled.h1`
  margin-bottom: 20px;

  font-size: 24px;
  font-weight: ${fontWeightBold};
  text-align: left;
`
const Flex = styled.div`
  margin-top: 20px;
  display: flex;
  margin-bottom: 20px;
`
const ItemContentImage = styled.img`
  border-radius: 50%;
  object-fit: cover;
  width: 98px;
  height: 98px;
  margin-right: 32px;
`
const CompanyName = styled.p`
  padding-top: 20px;
  padding-bottom: 4px;
`
const CompanyAdminName = styled.p`
  font-size: 20px;
  font-weight: ${fontWeightBold};
`
const ContentLabel = styled.label`
  font-weight: ${fontWeightBold};
`
const ContentTextarea = styled.textarea`
  margin-top: 8px;
  margin-bottom: 12px;
  padding: 20px;
  width: 100%;
  min-height: 400px;
  border-radius: 5px;
  border: 1px solid ${_introductory_text_border};
`
const ErrorMessage = styled.div`
  color: ${_formalert};
  margin-top: 10px;
`
const ModalButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  button {
    height: 42px;
    color: ${truewhite};
    padding: 4px 8px;
    width: 204px;
    font-size: 14px;
  }
`
const SaveButton = styled(SmallButton)`
  background: ${_profilegreen};
`
const CancelButton = styled(SmallButton)`
  background: ${lightgray};
`
